/** Workspace permission strings from the API (user_permissions). */
export const WORKSPACE_PERMISSION = {
  VIEW: 'view',
  EDIT: 'edit',
  ADMIN: 'admin',
};

/**
 * Capability flags returned by useWorkspacePermissions.
 * Use these for UI/route gating instead of raw role strings.
 */
export const WORKSPACE_CAPABILITY = {
  CAN_EDIT: 'canEdit',
  CAN_DELETE: 'canDelete',
  CAN_INVITE: 'canInvite',
  CAN_MANAGE_MEMBERS: 'canManageMembers',
  CAN_VIEW_SETTINGS: 'canViewSettings',
  CAN_MANAGE_BILLING: 'canManageBilling',
};
